import { Map } from 'immutable';
import { iDeviceDetails, iDevicePing, iList } from '../../../shared/interfaces';

export const SET_ALL_DEVICES_INFO = 'SET_ALL_DEVICES_INFO';
export const SET_DEVICE_INFO = 'SET_DEVICE_INFO';
export const UPDATE_DEVICE_LOCATION = 'UPDATE_DEVICE_LOCATION';
export const UPDATE_DEVICE_LOCATIONS = 'UPDATE_DEVICE_LOCATIONS';
export const FETCH_DEVICES_LATEST_PING = 'FETCH_DEVICES_LATEST_PING';
export const SET_DEVICES_LATEST_PING = 'SET_DEVICES_LATEST_PING';


export const setAllDevicesInfo = (devicesDetails: iList<iDeviceDetails>) => ({
    type: SET_ALL_DEVICES_INFO,
    payload: {devicesDetails},
});

export const setDeviceInfo = (deviceDetails: iDeviceDetails) => ({
    type: SET_DEVICE_INFO,
    payload: {deviceDetails},
});

export const updateDeviceLocation = (deviceId: string, ping: iDevicePing | null) => ({
    type: UPDATE_DEVICE_LOCATION,
    payload: {deviceId, ping},
});

export const updateDeviceLocations = (payload: Map<string, iDevicePing | null>) => ({
    type: UPDATE_DEVICE_LOCATIONS,
    payload,
});

export const fetchDevicesLatestPing = () => ({
    type: FETCH_DEVICES_LATEST_PING,
});

export const setDevicesLatestPing = (pingsData: Record<string, any>) => ({
    type: SET_DEVICES_LATEST_PING,
    payload: { pingsData }
});
